var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ChartParams } from "../../views/chart/chart.component";
import * as qs from 'clever-qs';
import { BillingService2 } from "../billing.service";
var ReturnComponent = /** @class */ (function (_super) {
    __extends(ReturnComponent, _super);
    function ReturnComponent(activatedRoute, translate, filter, eventsService, router, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.router = router;
        _this.service2 = service2;
        _this.returnChart = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        _this.count = 0;
        _this.sum = 0;
        _this.addFilterParams = {
            userType: 'user',
            isExpiredPaid: true,
            dateFilters: ['dateReturn', 'datePaid', 'dateCreated', 'dateSiteCreated'],
            dateType: 'dateReturn',
        };
        _this.returnChart.setOptions({
            title: _this.translate.__A('common.Returns'),
            showLabels: [
                'moneyCount', 'count'
            ],
            names: {
                'count': _this.translate.__A('common.Count'),
                'moneyCount': _this.translate.__A('common.total'),
            },
            data: {
                axes: {
                    moneyCount: 'y',
                    count: 'y2'
                }
            },
            axes: {
                moneyCount: 'y',
                count: 'y2'
            },
            axis: {
                x: {
                    tick: {
                        fit: false,
                        format: '%d-%m-%Y'
                    }
                },
                y2: {
                    show: true
                }
            }
        });
        return _this;
    }
    ReturnComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!this.dontLoad.pagination) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        this.paginationLoader = true;
                        return [4 /*yield*/, this.service2.return.pagination(this.filter.filterParams).toPromise()];
                    case 3:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.service2.return.getRealFullRoute());
                        }
                        this.paginationLoader = false;
                        return [4 /*yield*/, this.getStats()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, _a, count, sum, stats;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        fp = me.filter.getFilterParams();
                        fp.paginationDate = me.pagination.getDate();
                        me.stats = [];
                        me.count = 0;
                        me.sum = 0;
                        this.paginationLoader = true;
                        return [4 /*yield*/, me.service2.return.stats(fp).toPromise()];
                    case 1:
                        _a = _b.sent(), count = _a.count, sum = _a.sum, stats = _a.stats;
                        this.paginationLoader = false;
                        me.stats = stats;
                        me.count = count;
                        me.sum = sum;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (this.dontLoad.chart) {
                            return [2 /*return*/, true];
                        }
                        fp = me.filter.getFilterParams();
                        me.returnChart.showLoader();
                        return [4 /*yield*/, me.service2.return.chart(fp).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.returnChart.data = charts;
                        me.returnChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnComponent.prototype.getTotalAmount = function () {
        return this.stats.reduce(function (count, stat) { return count + stat.usdAmount; }, 0);
    };
    ReturnComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams);
                url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    return ReturnComponent;
}(BaseComponent));
export { ReturnComponent };
